import {
  DECORATION_CONSULT_GIFT,
  DECORATION_DEFAULT_TEXT,
  PRIVILEGE_CONSULT_GIFT,
  PRIVILEGE_STATUS_REJECTED,
  PRIVILEGE_STATUS_VERIFYING
} from '@constant'
import { dGet } from '@core/utils'
import { ctrlTextLen } from '@hlj/hlj-utils'
import { isSiDaProperty, isUltimate } from '@merchant-backend/util'
import { isSiDaMember } from '@util'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import GiftRow from '../Common/GiftRow'
import Rowbox from '../Common/Rowbox'

@observer
export default class extends Component {
  getStatus = () => {
    const { allStatus } = this.props.store

    let status = ''

    const privileges = dGet(allStatus, 'privileges', [])

    const gift = privileges.filter(
      item => +item.id === PRIVILEGE_CONSULT_GIFT
    )[0]

    if (gift) {
      if (gift.status == PRIVILEGE_STATUS_REJECTED) {
        status = 'rejected'
      } else if (gift.status == PRIVILEGE_STATUS_VERIFYING) {
        status = 'verifying'
      }
    }

    return status
  }

  showModule = (mode, gift) => {
    // 三大个人，但团队未设置
    if (isSiDaMember() && !gift) {
      return false
    }

    const { showAll } = this.props.store

    return (
      mode === 'editable' ||
      showAll ||
      (isUltimate() && mode === 'preview' && gift)
    )
  }

  render() {
    const { store } = this.props
    const { mode } = store
    const gift = dGet(store, 'merchantHomeData.merchant.privilege.consult_gift')
    const number = dGet(store, 'merchantHomeData.merchant.consult_gift_count')
    const text = gift || DECORATION_DEFAULT_TEXT[DECORATION_CONSULT_GIFT]
    const status = this.getStatus()

    return this.showModule(mode, gift) ? (
      <Rowbox
        type={DECORATION_CONSULT_GIFT}
        store={store}
        style={{
          height: 'auto',
          minHeight: 75,
          padding: '0 16px',
          marginBottom: 0
        }}
        vCenter={false}
        status={status}
        disableEdit={isSiDaMember() && gift}
      >
        <GiftRow>
          <GiftRow.Title
            title="咨询礼"
            showNumber={!isSiDaProperty()}
            num={`${number || 0}人领取`}
          />
          <GiftRow.Content content={<p>{ctrlTextLen(text, 20)}</p>} />
        </GiftRow>
      </Rowbox>
    ) : null
  }
}
